import { render, staticRenderFns } from "./DialogDocument.vue?vue&type=template&id=1a5a2198"
import script from "./DialogDocument.vue?vue&type=script&lang=js"
export * from "./DialogDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports